import { dispatch } from '@rematch/core';
import {
  integrationsService,
  integrationsListService,
  addIntegrationInAccountService,
  integrationsProviderService,
  removeIntegrationsFromAccountService,
  editIntegrationsService,
  removeIntegrationService,
  testIntegrationService,
  entityIntegrationService,
  entityIntegrationConfigService,
  addIntegrationInOrgService
} from '../../services/feathers.service';

const initialState = {
  integrationsList: null,
  selectedIntegration: null,
  testResult: null,
  integrationEntities: null,
  entityIntegrationsConfig: null
};

export default {
  state: initialState,
  reducers: {
    setIntegrationList(state, payload) {
      return {
        ...state,
        integrationsList: payload
      }
    },
    setIntegration(state, payload) {
      return {
        ...state,
        selectedIntegration: payload
      }
    },
    setTestResult(state, payload) {
      return {
        ...state,
        testResult: payload
      }
    },
    setIntegrationEntities(state, payload) {
       return  {
        ...state,
        integrationEntities: payload
       }
    },
    setEntityIntegrationsConfig(state, payload){
      return  {
        ...state,
        entityIntegrationsConfig: payload
       }
    },
    clear() {
      return initialState
    }
  },
  effects: {

    async createIntegration(payload, state) {
      try {
        const createdIntegration = await integrationsService.create(payload);
      } catch (err) {

        throw err;
      }
    },
    async getIntegrations() {
      try {
        const allIntegrations = await integrationsListService.find();
        dispatch.integrations.setIntegrationList(allIntegrations);
      } catch (error) {
        console.log(error);
        throw (error);
      }

    },
    async getIntegrationEntities(selectedOrganisation,state) {

      if (selectedOrganisation && selectedOrganisation.integrations && selectedOrganisation.integrations.length > 0) {
        const integrationTypes =  selectedOrganisation.integrations.map((intElm) => 
              { return { type: intElm.type, option: intElm.option} });

        const integrationTypesArray = [];
        integrationTypes.forEach(elem => {
          if (elem.type && elem.option){
            integrationTypesArray.push(elem);
          }
        })
        
        let query = {
          integrationTypes: integrationTypesArray,
        }

        const result = await entityIntegrationService.find({
          query: query
        });
        dispatch.integrations.setIntegrationEntities(result);
      }
    },
    async addIntegrationInAccounts(payload, state) {
      try {
        let result = await addIntegrationInAccountService.patch(payload.account._id, payload);
        await dispatch.platform.getAllAccountsWithOwnerDetails(state.platform.subscriptionListQuery);
        await dispatch.account.getAllAccounts(payload.user._id);

      } catch (err) {
        throw (err);
      }
    },
    async addEntityIntegrationConfig(payload, state) {
      try {
        if (!payload.isUpdate) {
          await entityIntegrationConfigService.create(payload);
        }else {
          await entityIntegrationConfigService.patch(payload.entityIntegrationConfigId, {
            formData:payload.formData 
          });
        }
        
      } catch (err) {
        throw (err);
      }
    },
    async getEntityIntegrationConfig(payload, state) {
      try {
        const query = {
          entityId : payload.entityId
        }
        await dispatch.integrations.setEntityIntegrationsConfig([]);
        const result = await entityIntegrationConfigService.find({query});
        if (result.data && result.data.length > 0) {
          await dispatch.integrations.setEntityIntegrationsConfig(result.data);
        }else {
          await dispatch.integrations.setEntityIntegrationsConfig([]);
        }
      } catch (err) {
        throw (err);
      }
    },
    async removeIntegrationsFromAccount(payload, state) {
      try {
        let removeresult = await removeIntegrationsFromAccountService.patch(payload.account._id, payload);
      } catch (error) {
        throw (error)
      }
    },

    async editIntegrations(payload, state) {
      try {
        let result = await editIntegrationsService.patch(payload.id, payload);
      } catch (error) {
        throw (error);
      }
    },
    async deleteIntegrations(payload, state) {
      try {
        await removeIntegrationService.remove(payload._id, payload)
      } catch (error) {
        throw (error);
      }
    },
    async setSelectedIntegration(payload, state) {
      try {
        const selectedIntegration = await integrationsProviderService.get(payload);
        dispatch.integrations.setIntegration(selectedIntegration);
        dispatch.integrations.setTestResult(null);
      } catch (error) {
        throw (error);
      }
    },
    async testIntegration(payload, state) {
      try {
        const testResult = await testIntegrationService.create(payload);
        dispatch.integrations.setTestResult(testResult);
      } catch (error) {
        throw (error);
      }
    },


    async addIntegrationsInOrganization(payload, state) {
      try {
        const result = await addIntegrationInOrgService.patch(payload.selectedOrganisation.id, payload);
        dispatch.organizationTab.getCurrentOrganizationData(result[0]._id);
        dispatch.app.setSelectedOrganisationData(payload.selectedOrganisation);

      } catch (err) {
        throw (err);
      }
    },
  }
}